// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34uge","label":"styles_label__35w88"};